<template>
  <!-- 供电统计面板 -->
  <div>
    <div class="fr ov pane-overall" style="height: 135px; width: 100%">
      <div id="chartDiv" ref="chartDiv" style="width: 240px; height: 135px; margin-left: 5px; margin-top: 3px;" />
      <div class="fc" style="width: 120px; height: 135px;">
        <div class="fr fc jc ac pane-data-block">
          <!-- <div class="pane-data-label">PUE</div> -->
          <div class="pane-data-value" style="font-size: 34px;margin-top: 40px;">{{ pue }}</div>
        </div>
        <div class="fr jc ac pane-data-block">
          <div class="fc jc ac pane-data-block">
            <div class="pane-data-label">机房总功耗(KW)</div>
            <div class="pane-data-value" style="color: #FFF;">{{ totalEnergy }}</div>
          </div>
          <div class="fc jc ac pane-data-block">
            <div class="pane-data-label">IT负载率(%)</div>
            <div class="pane-data-value" style="color: #FFF;">{{ itLoad }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {merge} from "lodash";
import chartConfig from "@/utils/chartConfig";
import hexRgb from "hex-rgb";
import { genHourList } from "@/views/sascreen/utils/genValues";

export default {
  name: 'pane-energy-pueline',
  components: {},
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.update()
      }
    }
  },
  data() {
    return {
      totalEnergy: '',
      itLoad: '',
      xAxisData: [],
      seriesData: [],
      pue: 1,

      chart: null,
      colors: [ '#FFC400', '#8AFCED', '#5A79FF', '#F67B7B' ], // 颜色列表
    }
  },
  mounted () {
    const chart = echarts.init(this.$refs.chartDiv)
    window.addEventListener('resize', () => {
      setTimeout(() => {chart.resize()}, 10)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', () => chart.resize())
      chart.dispose()
    })
    this.chart = chart

    this.$nextTick(function () {
      this.update()
    })
  },
  methods: {
    update () {
      if (!this.chartData) return
      this.totalEnergy = this.chartData.pueData.total_energy
      this.itLoad = this.chartData.pueData.it_load
      const { xAxisData, seriesData } = this.chartData.pueLine
      if (!xAxisData || !seriesData) return
      this.xAxisData = genHourList(seriesData.length)
      this.seriesData = seriesData
      this.pue = seriesData[seriesData.length-1]

      const option = merge({}, chartConfig, {
        grid: {
          top: 10,
          right: 15,
        },
        title: {
          show: false,
          text: this.chartTitle,
          textStyle: {
            fontFamily: '"OPPOSans R", "阿里巴巴普惠体 R", PingFangSC-Medium, PingFangSC, Arial, Helvetica, 黑体, sans-serif',
            fontSize: 15,
            fontWeight: '100',
            color: '#FFF1D9',
            textShadowBlur: 0,
          },
          left: 'left',
          top: '0',
        },
        legend: {
          show: false,
        },
        xAxis: {
          data: this.xAxisData,
          boundaryGap: false,
          splitLine: {
            show: false,
            interval: 0,
            lineStyle: {
              color: 'rgba(255,255,255,0.2)' // 坐标轴X轴线条颜色
            }
          },
          axisLabel: { // 坐标轴样式
            interval: 0, // 强制显示所有标签
            rotate: 0, // 如果标签过长，可以旋转显示
            fontSize: 10,
            color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
          },
        },
        yAxis: [
          {
            type: 'value',
            min: function (value) {
              return value.min - 0.3
            },
            max: function (value) {
              return value.max + 0.3
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              formatter: function (value) {
                return value.toFixed(1)
              },
              color: 'rgba(255,255,255,0.45)',
              fontSize: 10,
            },
          },
        ],
        series: [{
          data: this.seriesData,
          type: 'line',
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 5,
          coordinateSystem: 'cartesian2d',
          smooth: true,
        }]
      }, this.option)
      this.chart.setOption(option)
    },
  }
}
</script>

<style lang="css" scoped>

.pane-overall {
  width: 100%;
  background: rgba(0, 145, 133, 0.12);
}

.pane-data-block {
  width: 160px;
  height: 44%;
  margin-left: 10px;
}

.pane-data-value {
  line-height: 22px;
  font-size: 16px;
  font-family: Consolas, serif;
  color: #35FFF6;
  text-align: center;
  vertical-align: center;
  font-family: aldrich, serif;
}

.pane-data-label {
  line-height: 12px;
  font-size: 8px;
  color: #FFF;
}

</style>
